import { render, staticRenderFns } from "./RejectedCampaign.vue?vue&type=template&id=5588b060&scoped=true&"
import script from "./RejectedCampaign.vue?vue&type=script&lang=ts&"
export * from "./RejectedCampaign.vue?vue&type=script&lang=ts&"
import style0 from "./RejectedCampaign.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RejectedCampaign.vue?vue&type=style&index=1&id=5588b060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588b060",
  null
  
)

export default component.exports